
import { Button } from "@/components/ui/button";
import WorkoutLibrary from "../WorkoutLibrary";

interface WorkoutTemplatesViewProps {
  onBack: () => void;
}

const WorkoutTemplatesView = ({ onBack }: WorkoutTemplatesViewProps) => {
  return (
    <div className="relative">
      {/* Embed the existing WorkoutLibrary component */}
      <WorkoutLibrary onBack={onBack} />
    </div>
  );
};

export default WorkoutTemplatesView;
